import { useEffect, useState } from 'react';
import { Outlet, useLocation, Location } from 'react-router-dom';

// components
import { TopBar } from './components/top-bar/top-bar';
import { Sidebar } from './components/sidebar/sidebar';
import { GameTypeDashboardLayout } from '../components/gametype-carousel/gametype-carousel';
import { gameTypeSidebar } from './components/sidebar/metadata';

// material ui
import { Box } from '@mui/material';

// interfaces
import { IGame, mapGQLGame } from '@/shared/interfaces';

export function PageLayoutPage() {
  const sidebarWidth = 240;
  const location: Location = useLocation();
  const routepath = location.pathname.split('/');

  const [gameCtx, setGameCtx] = useState<IGame>(mapGQLGame());
  const [isSidebarCollapsed, setSsSidebarCollapsed] = useState(false);
  const [showGameTabs, setShowGameTabs] = useState(false);

  useEffect(() => {
    if (
      (routepath.length >= 3 && gameTypeSidebar.filter((item) => item.path === routepath[2] && item.path != '').length > 0) ||
      routepath.includes('usher-bets')
    ) {
      setShowGameTabs(true);
    } else {
      setShowGameTabs(false);
    }
  }, [routepath]);

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <TopBar sidebarWidth={sidebarWidth} isSidebarCollapsed={isSidebarCollapsed} setSsSidebarCollapsed={setSsSidebarCollapsed} />
        <Sidebar isSidebarCollapsed={isSidebarCollapsed} />
        <Box component="main" sx={{ flexGrow: 1, px: 3, pb: 3, pt: '64px' }}>
          {showGameTabs && <GameTypeDashboardLayout gameCtx={gameCtx} setGameCtx={setGameCtx} />}

          <Outlet context={{ gameCtx }} />
        </Box>
      </Box>
    </>
  );
}
